export default __webpack_public_path__ + "static/media/trashIcon.1be1b9bc.svg";